var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: _vm.classes,
      on: { mouseenter: _vm.handleMouseenter, mouseleave: _vm.handleMouseleave }
    },
    [
      _c(
        "div",
        {
          ref: "reference",
          class: [_vm.prefixCls + "-submenu-title"],
          style: _vm.titleStyle,
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClick.apply(null, arguments)
            }
          }
        },
        [
          _vm._t("title"),
          _vm._v(" "),
          _c("Icon", {
            class: [_vm.prefixCls + "-submenu-title-icon"],
            attrs: {
              type: _vm.arrowType,
              custom: _vm.customArrowType,
              size: _vm.arrowSize
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.mode === "vertical"
        ? _c("collapse-transition", [
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.opened,
                    expression: "opened"
                  }
                ],
                class: [_vm.prefixCls]
              },
              [_vm._t("default")],
              2
            )
          ])
        : _c(
            "transition",
            { attrs: { name: "slide-up" } },
            [
              _c(
                "Drop",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.opened,
                      expression: "opened"
                    }
                  ],
                  ref: "drop",
                  style: _vm.dropStyle,
                  attrs: { placement: "bottom" }
                },
                [
                  _c(
                    "ul",
                    { class: [_vm.prefixCls + "-drop-list"] },
                    [_vm._t("default")],
                    2
                  )
                ]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-143ce7ee", { render: render, staticRenderFns: staticRenderFns })
  }
}